import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Page } from 'components/base/layout-components';
import AppRouter from 'common/AppRouter';

import Projects from './Projects/Projects';
import ProjectExtended from './ProjectExtended';

const ProjectsRouter = props => {
  const { account } = props;
  const hasFavorites = !!account.settings.favorite_projects?.length;
  return (
    <Page>
      <Switch>
        <Route
          path={AppRouter.PROJECTS_API_FAVORITES.path}
          exact
          render={() => <Projects onlyFavorites={true} {...props} />}
        />
        <Route
          path={AppRouter.PROJECTS_API_ALL.path}
          exact
          render={() => <Projects {...props} />}
        />
        <Route
          path={AppRouter.PROJECT_API.path}
          exact
          render={() => <ProjectExtended {...props} />}
        />
        <Route
          path={AppRouter.PROJECTS_API.path}
          exact
          render={() => (
            <Redirect
              to={{
                pathname: hasFavorites
                  ? AppRouter.PROJECTS_API_FAVORITES.path
                  : AppRouter.PROJECTS_API_ALL.path,
                search: window.location.search
              }}
            />
          )}
        />
      </Switch>
    </Page>
  );
};

export default ProjectsRouter;
